import moment from 'moment';

import Logger from './logging';

export const isActivityListExpired = (timestamp) => {
	if (!timestamp) {
		return true;
	}
	Logger.log("home.js", "isActivityListExpired()", moment().diff(timestamp, 'minutes'));
	return moment().diff(timestamp, 'minutes') > 5;
};

export const isMyListExpired = (timestamp) => {
	if (!timestamp) {
		return true;
	}
	return false;
};



// WEBPACK FOOTER //
// ./src/functions/home.js